import { render } from "./TheAdminNavbar.vue?vue&type=template&id=6e9ee711&scoped=true"
import script from "./TheAdminNavbar.vue?vue&type=script&lang=ts"
export * from "./TheAdminNavbar.vue?vue&type=script&lang=ts"

import "./TheAdminNavbar.vue?vue&type=style&index=0&id=6e9ee711&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e9ee711"

export default script